import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from './axiosInstance';

export async function api<T>(config: AxiosRequestConfig): Promise<T> {
  const response = await axiosInstance.request(config);
  return response.data;
}
